/**
 * @desc 新增Models信息
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.Models): Promise<BaseResponse<defs.ResultBean>> {
  return fetch({
    url: config.API_HOST + '/api/base/vehicleType/save',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
